export const PERMS = {
    READ: 'payment_methods.read',
    UPDATE: 'payment_methods.update',
    DELETE: 'payment_methods.delete',
    CREATE: 'payment_methods.create',
    EXPORT: 'payment_methods.export',
}
